export default __webpack_public_path__ + "static/media/logo_new.3ee4e046.svg";